import styled from '@emotion/styled';
import { Badge } from 'antd';

export const Trigger = styled.div`
  width: 62px;
  padding: 12px 0 4px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  cursor: pointer;

  :hover {
    color: #fff;
  }

  > * {
    display: inline-block;
    vertical-align: middle;
  }

  .${({ theme }) => theme.getAntdPrefixedClassName('popover-arrow')} {
    display: none;
  }

  .${({ theme }) => theme.getAntdPrefixedClassName('popover-inner-content')} {
    padding: 5px 2px;
  }
`;
export const StyledBadge = styled(Badge)`
  color: inherit;
`;
